<div class="brand-names-container">
  <div class="brand-names">
    <a
      appDisableClickEvent
      class="brand-names__chip"
      *ngFor="let brand of brands | slice: NUMBER_0:limit"
      (click)="onBrandClick(brand.value)"
      [routerLink]="[getBrandPath(brand.value), brand.value]"
      >{{ brand.name | slice: NUMBER_0: NUMBER_25}}</a
    >
  </div>
</div>
